import { FC } from 'react';
import { trackEvent } from 'dibs-tracking';
import { useFragment, graphql } from 'react-relay';

// components
import { SeoLink } from 'dibs-seo/exports/SeoLink';
import { FormattedMessage } from 'dibs-react-intl';

// types
import { PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab$key as StoryTellingTab } from './__generated__/PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab.graphql';

const storyTellingTabQuery = graphql`
    fragment PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab on StoryTellingTab {
        browseLink {
            ...SeoLink_linkData
        }
        tabType
        contentHeader
        contentCreatorAttribution {
            __typename
        }
    }
`;

export const PdpSharedStoryTellingShopAllLink: FC<{ storyTellingTab: StoryTellingTab }> = ({
    storyTellingTab: storyTellingTabRef,
}) => {
    const storyTellingTab = useFragment(storyTellingTabQuery, storyTellingTabRef);
    const { browseLink, contentHeader, tabType } = storyTellingTab;

    if (!browseLink) {
        return null;
    }

    return (
        <SeoLink
            linkData={browseLink}
            dataTn="pdp-storytelling-shop-all-link"
            target="_blank"
            onClick={() => {
                trackEvent({
                    category: 'product',
                    action: `shop all ${tabType} clicked`,
                    label: 'pdp',
                });
            }}
        >
            {tabType === 'iconic design' ? (
                <FormattedMessage
                    defaultMessage="Shop The {name}"
                    id="PdpSharedStoryTellingShopAllLink.shopThe"
                    values={{ name: contentHeader }}
                />
            ) : (
                <FormattedMessage
                    defaultMessage="Shop All {name}"
                    id="PdpSharedStoryTellingShopAllLink.shopAll"
                    values={{ name: contentHeader }}
                />
            )}
        </SeoLink>
    );
};
